import { useCallback, useState } from "react"
import { User, postLogin } from "./api"

export const LoginScreen = ({
  onLoggedIn,
}: {
  onLoggedIn: (loggedInUser: User) => void
}) => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string>()
  const [loading, setLoading] = useState(false)

  const login = useCallback(async () => {
    setError(undefined)

    if (!email.includes("@")) {
      setError("Make sure you entered a correct email")
      return
    }

    setLoading(true)
    try {
      const loggedInUser = await postLogin(email, password)
      if (loggedInUser === undefined) {
        setError("Invalid email or password")
      } else {
        onLoggedIn(loggedInUser)
      }
    } catch (error) {
      setError("Something went wrong, please try again.")
    } finally {
      setLoading(false)
    }
  }, [email, password, onLoggedIn])

  return (
    <>
      <div className="Login">
        {error !== undefined && <p className="App-api-error">{error}</p>}
        <form
          onSubmit={(event) => {
            event.preventDefault()
            login()
          }}
        >
          <input
            className="App-input email"
            type="text"
            value={email}
            placeholder="Email"
            onChange={(event) => {
              setEmail(event.target.value)
              setError(undefined)
            }}
          />
          <input
            className="App-input password"
            type="password"
            value={password}
            placeholder="Password"
            onChange={(event) => {
              setPassword(event.target.value)
              setError(undefined)
            }}
          />
          {loading ? (
            <div className="loader" />
          ) : (
            <input
              className="App-button login"
              type="submit"
              value="Log in"
              disabled={loading}
            />
          )}
        </form>
      </div>
    </>
  )
}
